import React from "react";

import "./index.scss";

const Typography = ({
  text,
  className,
  variant = "title",
}) => {
  return <h4 className={`${className} ${variant}`}>{text}</h4>;
};

export default Typography;
